export class OrganizationStep3FormResultKeys {
    static readonly LNG = 'form_organization_step_3_field_correspondence_lang';
    static readonly PROFESSION = 'form_organization_step_3_field_profession';
    static readonly ISSUER = 'form_organization_step_3_field_issuer';
    static readonly COMMENT = 'form_organization_step_3_field_comment';
    static readonly NUMBER = 'form_organization_step_3_field_number';
    static readonly ISSUE_DATE = 'form_organization_step_3_field_issue_date';
    static readonly EMAIL = 'form_organization_step_3_field_email';
    static readonly FIRST_NAME = 'form_organization_step_3_field_first_name';
    static readonly LAST_NAME = 'form_organization_step_3_field_last_name';
}

export interface IOrganizationStep3FormResultKeys {
    form_organization_step_3_field_correspondence_lang: boolean;
    form_organization_step_3_field_profession: number;
    form_organization_step_3_field_issuer: number;
    form_organization_step_3_field_comment: string;
    form_organization_step_3_field_number: string;
    form_organization_step_3_field_issue_date: string;
    form_organization_step_3_field_email: string;
    form_organization_step_3_field_first_name: string;
    form_organization_step_3_field_last_name: string;
}
